export enum CacheType {
  Communications = 'communications',
  Orders = 'orders',
  GenericOrders = 'genericOrders',
  Campaigns = 'campaigns',
  Accidents = 'accidents',
  Actions = 'actions',
  ActionBudgetItems = 'actionBudgetItems',
  SurveillanceRoutes = 'surveillanceRoutes',
}
